var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMaterialMail = function SvgMaterialMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e8eaed",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.26-187.27q-28.35 0-48.27-19.92-19.91-19.91-19.91-48.27v-449.08q0-28.36 19.91-48.27 19.92-19.92 48.27-19.92h607.48q28.35 0 48.27 19.92 19.91 19.91 19.91 48.27v449.08q0 28.36-19.91 48.27-19.92 19.92-48.27 19.92zM480-460.71 164.04-663.12v407.58q0 5.39 3.46 8.85t8.85 3.46h607.3q5.39 0 8.85-3.46t3.46-8.85v-407.58zm0-58.48 309-197.58H171zM164.04-663.12v-53.65 461.23q0 5.39 3.46 8.85t8.85 3.46h-12.31z"
  })));
};
export default SvgMaterialMail;